/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Fit_Files_DescInputs */

const en_ui_fit_files_desc = /** @type {(inputs: Ui_Fit_Files_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original recordings from Garmin, Wahoo, Zwift & co. — or your whole history as a .zip.`)
};

const de_ui_fit_files_desc = /** @type {(inputs: Ui_Fit_Files_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originalaufzeichnungen von Garmin, Wahoo, Zwift & Co. – oder deine ganze Historie als .zip.`)
};

/**
* | output |
* | --- |
* | "Original recordings from Garmin, Wahoo, Zwift & co. — or your whole history as a .zip." |
*
* @param {Ui_Fit_Files_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_fit_files_desc = /** @type {((inputs?: Ui_Fit_Files_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Fit_Files_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_fit_files_desc(inputs)
	return de_ui_fit_files_desc(inputs)
});